import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const RouteWrapper = ({ component: Component, isPrivate = false }) => {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <BackdropLoading />;

  if (!isAuth && isPrivate) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isAuth && !isPrivate) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};

export default RouteWrapper;
